module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product13-61182555a33fb2f2c14cd3987ee71313.jpg";